import React, { createContext, useCallback, useContext, useState } from 'react';

const STORAGE_KEY = 'p5_lang';

const LangContext = createContext({ lang: 'en', toggleLang: () => {} });

export function LangProvider({ children }) {
  const [lang, setLang] = useState(
    () => localStorage.getItem(STORAGE_KEY) || 'en',
  );

  const toggleLang = useCallback(() => {
    setLang((prev) => {
      const next = prev === 'en' ? 'th' : 'en';
      localStorage.setItem(STORAGE_KEY, next);
      return next;
    });
  }, []);

  return (
    <LangContext.Provider value={{ lang, toggleLang }}>
      {children}
    </LangContext.Provider>
  );
}

export function useLang() {
  return useContext(LangContext);
}

// helper: L('ไทย', 'English') — คืนค่าตาม lang ปัจจุบัน
export function useL() {
  const { lang } = useLang();
  return useCallback((th, en) => (lang === 'en' ? en : th), [lang]);
}
